import { render, staticRenderFns } from "./ChooseReservedSlotForm.vue?vue&type=template&id=18025679&scoped=true"
import script from "./ChooseReservedSlotForm.vue?vue&type=script&lang=ts"
export * from "./ChooseReservedSlotForm.vue?vue&type=script&lang=ts"
import style0 from "./ChooseReservedSlotForm.vue?vue&type=style&index=0&id=18025679&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18025679",
  null
  
)

export default component.exports